import React from "react";
import "url-search-params-polyfill";
import IndexTable from "../../components/table/index.js";
import Item from "./item";
import { I18n } from "../../i18n";
import { CategoryService } from "../../services/SelectOptionService";

class Category extends React.Component {
  render() {
    const path = "category";

    // switch int18 by phase

    // category uses common texts for translation
    const i18nProps = {
      i18n:
        !this.props.user || this.props.user.currentPhaseNumber === 1
          ? I18n[this.props.lang].categories
          : I18n[this.props.lang].categories_p2,
      i18nCommon: I18n[this.props.lang].common,
    };

    return (
      <IndexTable
        {...this.props}
        {...i18nProps}
        serviceClass={CategoryService}
        path={path}
        columns={[
          { id: "id", title: "ID", center: true },
          { id: "langKey", title: "Language Key" },
          { id: "ua", title: "UA" },
          { id: "en", title: "EN" },
          {
            id: "active",
            title: "Active",
            displayFunc: (r) => (r.active ? "True" : "False"),
          },
          { id: "descEn", title: "Desc En" },
          { id: "descUa", title: "Desc Ua" },
          { id: "result", title: "Result" },
          { id: "keywords", title: "Keywords" },
        ]}
        onEditItem={(itemId, item, handleItemSave, props) => {
          return (
            <Item
              item={item}
              itemId={itemId}
              indexPath={path}
              handleItemSave={handleItemSave}
              isEditable={true}
              {...i18nProps}
              {...this.props}
            />
          );
        }}
        onViewItem={(itemId, item, props) => {
          return (
            <Item
              item={item}
              itemId={itemId}
              indexPath={path}
              isEditable={false}
              {...i18nProps}
              {...this.props}
            />
          );
        }}
      />
    );
  }
}

export default Category;
